import createCache from '@emotion/cache'
import { CacheProvider } from '@emotion/react'

export const cacheOptions = {
  key: 'g' // the key is prepended to class names generated by emotion
}

export const gremlinCache = createCache(cacheOptions)

export default function EmotionProvider(props) {
  return <CacheProvider value={gremlinCache} {...props} />
}
